export const termsAndConditions = `Lorem ipsum dolor sit amet, consectetur adipiscing
elit. Quisque
id egestas eros, a
volutpat elit. Nunc rhoncus, est vitae convallis laoreet, magna nulla pellentesque
mauris, sed ullamcorper nibh eros vel elit. In hac habitasse platea dictumst.
Pellentesque malesuada tellus vel laoreet eleifend. Vestibulum libero nisi,
fringilla in fermentum in, laoreet eget massa. Phasellus lobortis quis ex ac
viverra. Aliquam erat volutpat. Suspendisse potenti. Class aptent taciti sociosqu ad
litora torquent per conubia nostra, per inceptos himenaeos. Sed et tortor nec metus
volutpat pellentesque eget quis urna.

Nullam consequat urna gravida auctor venenatis. Pellentesque habitant morbi
tristique senectus et netus et malesuada fames ac turpis egestas. Phasellus sit amet
dolor odio. Phasellus mi elit, mollis eget pharetra eget, vehicula quis odio. In
fermentum, leo id rutrum egestas, turpis justo ornare elit, ac blandit sapien urna
ac metus. Morbi ultrices sem non tortor varius auctor. Morbi congue nisl metus, eget
lacinia lacus gravida ac. Sed pretium gravida quam id aliquet. Fusce et turpis et mi
tempus iaculis. Cras tempus diam sit amet leo finibus faucibus. Etiam dapibus sapien
eget sem semper egestas.

Praesent eget pulvinar ipsum. Pellentesque eget ex ante. Aliquam imperdiet gravida
sapien in commodo. Sed tincidunt mollis faucibus. Curabitur eu pulvinar ipsum, vitae
aliquet orci. Praesent erat est, rhoncus sed sollicitudin non, congue non orci. Sed
eget vestibulum eros, a molestie nibh. Suspendisse potenti.

Sed eget aliquet tellus. Nunc gravida pellentesque libero, ut vulputate libero
pretium quis. Morbi ligula nunc, consequat eget lacus a, ultricies mattis magna. Sed
quis ante id ligula sodales hendrerit nec et ipsum. Aliquam sem erat, tempor quis
dui ut, ultricies lacinia velit. Nulla ipsum odio, condimentum ut tempus bibendum,
tempor at nibh. Nullam ornare facilisis massa, eu cursus nibh mattis tempor.

Nullam mollis turpis ac diam tempus bibendum. Vestibulum consectetur, metus id
rhoncus volutpat, urna urna accumsan diam, quis tempor diam ante vitae est. Ut elit
turpis, consequat condimentum volutpat sit amet, molestie id purus. Nullam eget
rhoncus eros. Sed ut ante eget enim pulvinar faucibus ac nec arcu. Quisque luctus
placerat lacus quis pretium. Proin ac elit nunc. Vivamus vel laoreet tortor. Aliquam
lectus quam, consequat et fringilla vitae, suscipit eu diam. Sed malesuada rutrum
risus, blandit pretium ligula pretium vel. Mauris fermentum nisi non ipsum
convallis, vitae aliquet mauris dapibus. Aenean at venenatis dolor. Suspendisse sed
justo vel est ullamcorper aliquet sit amet in orci.

Aliquam nec sapien maximus nisi eleifend elementum id sit amet tellus. Etiam nec
ante non enim facilisis aliquet. Suspendisse lorem arcu, egestas ac scelerisque et,
lobortis eget dolor. Suspendisse maximus, velit eu rhoncus dignissim, turpis sem
tincidunt nibh, sit amet ultricies orci ipsum eu velit. Phasellus vel aliquet ipsum,
at congue enim. Integer gravida iaculis volutpat. Sed urna urna, lacinia a dolor
varius, convallis ultricies velit. Quisque dictum elit vitae nulla viverra, ut
congue libero facilisis. Praesent ullamcorper dapibus volutpat.

Morbi sodales cursus elit, a ullamcorper elit sodales eu. Cras vestibulum gravida
est, eget accumsan nibh mattis et. Donec id sapien quis nisl ornare consequat.
Maecenas ornare quam vitae mollis mattis. In at quam ultrices, hendrerit dui sit
amet, feugiat odio. Duis sodales metus sit amet quam malesuada blandit euismod vitae
erat. Nulla ullamcorper euismod diam ac elementum.

Duis eleifend, lorem sed elementum rutrum, velit nulla porta leo, et venenatis dolor
eros quis elit. Proin ut lacus ac ante aliquam molestie. Vivamus auctor urna sit
amet nisi elementum, nec venenatis orci tristique. Vestibulum sagittis eget lorem
non sollicitudin. Morbi id gravida turpis. Orci varius natoque penatibus et magnis
dis parturient montes, nascetur ridiculus mus. Cras eget bibendum metus. Nullam vel
congue massa, vel aliquet sapien. Donec sit amet neque ex.

Quisque auctor tellus ac arcu finibus, non gravida magna interdum. Ut varius ipsum
est, ut accumsan lectus tempor ac. Curabitur in purus mi. Praesent dapibus nisi vel
mauris dapibus, sit amet pretium turpis fringilla. Duis tempus nisl luctus mauris
tempus tristique. Nam sagittis sem vitae risus finibus, at rutrum nulla imperdiet.
Duis et turpis at orci finibus interdum eu at lacus.

Etiam porttitor dolor at purus tempus, in porta odio blandit. Nullam eu orci sit
amet ligula tincidunt vehicula. Vestibulum facilisis libero non porttitor porta.
Donec id vulputate turpis, sed dapibus augue. Sed mattis consequat nisi, a lobortis
libero finibus at. Etiam ut arcu tincidunt, auctor arcu ut, fringilla sem. Sed
venenatis lectus nulla, vehicula maximus ipsum suscipit vel. Sed tempor eros sed
dapibus dictum.

Curabitur eu sem vitae nunc suscipit fringilla. Maecenas mattis pellentesque mauris,
vitae pretium ex pulvinar ac. Duis condimentum nunc in sagittis molestie. In a magna
ac nulla vulputate commodo at ultricies mauris. Sed sit amet nibh mattis,
pellentesque ligula eu, porttitor neque. Nam tristique libero interdum, molestie
lectus lobortis, hendrerit risus. Aenean fermentum massa at turpis sollicitudin
ornare. Maecenas risus ipsum, iaculis et faucibus a, suscipit a libero. Cras nec
nulla ultrices, consectetur turpis vel, tristique leo. Fusce eget massa lorem. Donec
ullamcorper leo eget pretium congue. Suspendisse rutrum urna vitae tellus maximus
suscipit. Etiam mattis nec ante sed sollicitudin. Ut nisi elit, molestie in auctor
at, tristique a tortor. Fusce laoreet quam elit, at interdum odio fringilla quis.
Sed lobortis quam et enim sollicitudin tincidunt.

Etiam eget quam malesuada, pharetra sem sed, ullamcorper ipsum. Integer vehicula
luctus augue, sit amet fringilla lectus feugiat nec. Sed augue purus, pharetra ac
venenatis vel, sagittis id lacus. Integer eget purus eu dui faucibus sollicitudin.
Suspendisse tincidunt, erat et ullamcorper congue, mi sem pretium sem, a hendrerit
nunc elit ac orci. Mauris et leo sed nunc ullamcorper dictum. Curabitur imperdiet
nibh ex, et auctor eros fringilla a. Ut ex neque, malesuada id libero vitae,
ullamcorper sollicitudin nisi. Maecenas nisl ipsum, molestie in leo nec, laoreet
porttitor est. Fusce tortor ante, varius sit amet arcu at, euismod blandit augue. In
pharetra ultricies sollicitudin. Pellentesque id mauris lorem. Sed accumsan lorem
eget faucibus venenatis. Nulla volutpat nibh odio, at elementum risus vestibulum
quis. Sed vestibulum orci et eros pretium, vel pharetra justo accumsan. Duis a odio
lorem.

Cras at eros nec sapien pretium pulvinar. Class aptent taciti sociosqu ad litora
torquent per conubia nostra, per inceptos himenaeos. Nullam dictum odio ut justo
congue gravida. Duis iaculis mi eu orci consequat ultrices. Praesent non ultrices
enim. Praesent lobortis nunc et mattis dignissim. Aliquam et justo felis. Etiam
bibendum placerat nunc nec laoreet. Lorem ipsum dolor sit amet, consectetur
adipiscing elit. Pellentesque habitant morbi tristique senectus et netus et
malesuada fames ac turpis egestas. Sed nec ipsum tempus, tristique dolor eu, luctus
nisi. Cras sodales elit sed felis dictum, varius semper sapien cursus. Donec
efficitur purus quam, tristique suscipit ex dignissim id.

Vivamus blandit condimentum sollicitudin. Nunc nec velit metus. Donec consequat
vulputate dolor. Nunc venenatis, massa id cursus bibendum, enim neque porttitor
orci, in elementum libero dui vitae nunc. Aenean enim nisi, dapibus sed facilisis
sit amet, rhoncus at eros. Quisque molestie a purus ut condimentum. Phasellus magna
mi, viverra non congue hendrerit, porta vitae eros. Nam elit turpis, sollicitudin in
turpis ac, scelerisque aliquet metus. Maecenas et metus ac mauris ultricies aliquet
ut at enim. Duis efficitur, eros vel pulvinar pretium, ante arcu laoreet eros, non
sollicitudin dolor enim in elit.

Donec congue enim nec rhoncus aliquet. Aenean feugiat lacus eget nunc ornare, ut
ullamcorper nisi dignissim. Duis sagittis et ex at aliquet. Vestibulum non pulvinar
leo. Donec porttitor sagittis facilisis. Morbi sed nisi eu velit venenatis lacinia.
Fusce ut luctus enim, nec suscipit augue. Proin eget neque dapibus, aliquet elit
quis, placerat tortor. Suspendisse potenti. Sed vel consequat mauris. Nulla finibus
interdum viverra. Interdum et malesuada fames ac ante ipsum primis in faucibus.`